import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	padding: 2rem 1.5rem 3rem;
	background: white;
`;

const Inner = styled.div`
	max-width: 72rem;
	margin: 0 auto;
`;

const Title = styled.h2`
	text-transform: uppercase;
	font-size: 1.5rem;
	letter-spacing: 0.2em;
	text-align: center;
	margin-bottom: 1.5rem;
`;

const Grid = styled.div`
	display: grid;
	gap: 1.5rem;
`;

export default function FloorplanBlockAlpha({ floors }: { floors: MicrositeResponsiveImage[] }) {
	if (floors.length === 0) return null;

	return (
		<Section id="floorplans">
			<Inner>
				<Title>Floor Plans</Title>
				<Grid>
					{floors.map((floor, index) => (
						<div key={index}>
							<MicrositeResponsiveImg image={floor} priority={LoadPriority.FIRST_PAINT} />
						</div>
					))}
				</Grid>
			</Inner>
		</Section>
	);
}
